import { ListType } from '../../shared/enums/list-type.enum';
import { Question } from './question.model';

// Without this dynamic parameter AOT compiling will fail.
// @see https://angular.io/guide/angular-compiler-options#strictmetadataemit
// @dynamic
export class ListQuestion extends Question {
  public numberOfAnswers!: number;

  public listType!: ListType;

  public static fromDto(dto: any): ListQuestion {
    const question: ListQuestion = new ListQuestion();
    Question.mapBaseProperties(question, dto);
    question.numberOfAnswers = dto.numberOfAnswers;
    question.listType = dto.listType;
    return question;
  }
}
